export const fetchData = (url) => {
    return fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
};
